import ReactPaginate from "react-paginate";
import pagNext from "../../public/assets/pag-next.svg";
import pagPrev from "../../public/assets/pag-prev.svg";
import Image from "next/image";

export default function Pagination({ currentPage, pageCount, onPageChange }) {
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    onPageChange(newPage);
  };

  return (
    <div className="flex items-center justify-center pt-40 pb-80 640:pt-20 640:pb-60 1024:pt-40 1024:pb-80">
      <ReactPaginate
        breakLabel="..."
        nextLabel={<Image src={pagNext} width={24} height={24} alt="Next" />}
        onPageChange={handlePageClick}
        pageRangeDisplayed={2}
        pageCount={pageCount}
        previousLabel={
          <Image src={pagPrev} width={24} height={24} alt="Next" />
        }
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
        containerClassName="flex items-center gap-x-8"
        pageClassName="pagination w-36 h-36 p-8 text-xxs font-medium"
        activeClassName="active"
        previousClassName="w-36 h-36 p-8"
        nextClassName="w-36 h-36 p-8"
        disabledClassName="opacity-50 cursor-not-allowed"
      />
    </div>
  );
}
